import React, { memo } from 'react'

import { Toggle } from '@cgtrader/triangle-ui/dist/src/ssr-index'

import usePrivateModeAccess from 'Pods/ThreeDStudio/Hooks/usePrivateModeAccess'
import useTranslation from 'Pods/ThreeDStudio/Hooks/useTranslation'
import PaidFeatureBadge from 'Pods/ThreeDStudio/Shared/PaidFeatureBadge/PaidFeatureBadge'

import { NOOP } from 'Utils/stableDefaults'

const TOGGLE_ID = 'composer-private-toggle'

function PrivateToggle() {
  const t = useTranslation()
  const hasPrivateModeAccess = usePrivateModeAccess()

  return (
    <div className="private-toggle">
      <label htmlFor={TOGGLE_ID} className="private-toggle__label cgt-button-text-base-semibold">
        {t('imageAssistantPanel.createTab.composer.private')}
      </label>
      <Toggle id={TOGGLE_ID} isChecked={false} onChange={NOOP} className="private-toggle__switch" />
      {!hasPrivateModeAccess && (
        <PaidFeatureBadge className="private-toggle__badge" label={t('shared.subscribersOnly.title')} />
      )}
    </div>
  )
}

export default memo(PrivateToggle)
